var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',[_c('div',{class:["checkbox-page"]},[_c('base-container',[_c('default-checked-checkbox'),_c('disabled-checkbox'),_c('desc-checkbox'),_c('styled-checkbox')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }